import { render, staticRenderFns } from "./EventsOverviewPage.vue?vue&type=template&id=6f450d04"
import script from "./EventsOverviewPage.vue?vue&type=script&lang=js"
export * from "./EventsOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./EventsOverviewPage.vue?vue&type=style&index=0&id=6f450d04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports